import { reduxForm, SubmissionError } from 'redux-form';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { noCredentials as http } from 'helpers/axios';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import UserForm from '../components/UserForm';

const validate = values => {
  const errors = {};
  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Must match password';
  }
  return errors;
};

const $reduxForm = reduxForm({
  form: 'setupUserForm',
  validate,
  onSubmit: (values, dispatch, props) => {
    const params = _.assign(_.omit(values, ['confirmPassword']), {
      token: props.token,
    });
    return http.post('/users', params).catch(error => {
      const { status, data } = error.response;
      if (status === 422) {
        throw new SubmissionError(data.errors);
      }
      throw new SubmissionError({
        _error:
          'We could not create your account. Please, contact one administrator.',
      });
    });
  },
  onSubmitSuccess: (result, dispacth, props) => {
    props.setSuccess(true);
  },
});

const $lifecycle = lifecycle({
  componentDidMount() {
    const { invite } = this.props;
    const initialValues = _.pick(invite, ['firstName', 'lastName', 'email']);
    this.props.setFirstName(initialValues.firstName);
    this.props.setLastName(initialValues.lastName);
    this.setState({
      initialValues,
    });
  },
});

const enhance = compose(
  withRouter,
  withState('success', 'setSuccess', false),
  withState('firstName', 'setFirstName'),
  withState('lastName', 'setLastName'),
  $lifecycle,
  $reduxForm,
  withHandlers({
    onComplete: props => () => {
      props.history.push('/login');
    },
    onChangeFN: props => event => {
      props.setFirstName(event.target.value);
    },
    onChangeLN: props => event => {
      props.setLastName(event.target.value);
    },
  })
);

export default enhance(UserForm);
